import React, { createContext, useState } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button as ChakraButton,
} from '@chakra-ui/react';
import { Button } from '~/components';
import { DialogContextData, DialogProviderProps, DialogConfig } from './types';

export const DialogContext = createContext<DialogContextData>(
  {} as DialogContextData,
);

export const DialogProvider: React.FC<DialogProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState<DialogConfig>(
    {} as DialogConfig,
  );

  function openDialog({
    title,
    text,
    isInformativeOnly = false,
    actionCallback,
  }: DialogConfig) {
    setDialogConfig({ title, text, isInformativeOnly, actionCallback });
    setIsOpen(true);
  }

  function resetDialog() {
    setIsOpen(false);
    setDialogConfig({} as DialogConfig);
  }

  function onConfirm() {
    resetDialog();
    dialogConfig.actionCallback(true);
  }

  const onDismiss = () => {
    dialogConfig.actionCallback && dialogConfig.actionCallback(false);
    resetDialog();
  };

  return (
    <DialogContext.Provider value={{ openDialog }}>
      {children}
      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        leastDestructiveRef={undefined}
        onClose={() => onDismiss()}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {dialogConfig.title}
            </AlertDialogHeader>
            <AlertDialogBody>{dialogConfig.text}</AlertDialogBody>
            <AlertDialogFooter>
              <Button onClick={() => onDismiss()} variant="secondary">
                Cancelar
              </Button>
              <ChakraButton
                colorScheme="red"
                onClick={() => onConfirm()}
                ml={3}
              >
                Excluir
              </ChakraButton>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </DialogContext.Provider>
  );
};
